<template>
  <b-container class="pb-0">
    <announcement-card :announcement="announcement" switch1Text="Show on Startup" buttonText="Got It!" @button="announcementClick($event)" />
  </b-container>
</template>

<script>
  // @ is an alias to /src
  import AnnouncementCard from '@/components/AnnouncementCard.vue'

  export default {
    name      : 'announcement',
    components: {
      AnnouncementCard
    },
    data() {
      return {
        announcement:
          {
            title      : "myCase Features",
            subTitle   : "v0.01.26",
            subHeader  : "Here are some new features",
            description:
`# New Release 8-)

Implementing HTML replacements, and as much markdown as we can handle without compromising system security.

This should allow for release notes to be posted here pretty easily.

## Work In Progress

***

We did a few changes - hopefully they are good ones! :wink:

***

## Changes

Some better than others

+ Did something on the app
+ Implemented Markdown in this window if you want to take the time to mark it down (or up, whichever you prefer)
+ Hard coded the colors to "dark"
+ Might not be the best idea, but can change this in a later version
+ Changed something on the app
  - Did some more stuff on the app
  - And some more stuff
  - Took a break and evaluated
  - Did a little more
  - Think I like the scrolling window and modified the scroll-bar to fit this new style
  - Going to noodle this a little before I consider this a "done" control
+ Thought about it a while
+ Tweaked some CSS
+ Tweaked MORE CSS
+ Yikes, even more CSS
+ Finished the changes and published




(c) 2019, **IOIHAN** Research
_All Rights Reserved_
`
            // moreInformation: "http://sandbox.ioihan.com:3001/doc/ingredients-stlukes.pdf",
            // tip            : "See Ingredient File"
        }
      }
    },
    methods: {
      announcementClick( results ) {
        console.log( results );
        alert( "Thank you!  Switch is " + ((results.switch1) ? "Yes" : "No"));
      }
    }
  }
</script>

